import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import formControl from './formControl';

function InvoicingPeriodSelect({
  input: { value, onChange, onBlur },
  invoicingPeriods,
  disabled,
}) {
  return (
    <select
      className="form-control"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      data-testid="InvoicingPeriodSelect"
      disabled={disabled}
    >
      {invoicingPeriods.map(paymentPeriod => (
        <option
          key={paymentPeriod.value}
          value={paymentPeriod.value}
        >
          {paymentPeriod.name}
        </option>
      ))}
    </select>
  );
}

InvoicingPeriodSelect.defaultProps = {
  invoicingPeriods: [
    { value: '', name: 'Alla' },
    { value: 'weekly', name: 'Varje vecka' },
    { value: 'monthly', name: 'En gång i månaden' }
  ],
  disabled: false,
};

InvoicingPeriodSelect.propTypes = {
  disabled: PropTypes.bool,
};

export default compose(  
  formControl,
)(InvoicingPeriodSelect);
